// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__HutPi","filesListContainer":"PosDisputesFiles_filesListContainer__3mDSB","filesButton":"PosDisputesFiles_filesButton__3XrXX"};